var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('BusinessBannerDesktop',_vm._b({},'BusinessBannerDesktop',_vm.$attrs,false)):_c('BusinessBannerMobile',_vm._b({},'BusinessBannerMobile',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }